import React from 'react';
import {PagingProvider, SearchProvider} from '@thinkwell/react.common';
import {AppProvider} from '@thinkwell/react.polaris';
import { ContentsProvider } from '../contexts/Contents'
import Contents from './Contents'

export default function Index(props) {
  return ( <AppProvider>
    <SearchProvider search={props.query}>
    <PagingProvider previous_page_info={props.previous_page_info} next_page_info={props.next_page_info} page={props.page}>
    <ContentsProvider value={props.items}>
      <Contents type={props.type}/>
    </ContentsProvider>
    </PagingProvider>
    </SearchProvider></AppProvider>)
}
